export class GlobalSearchTracking {
  static readonly TRACKER_GLOBAL_SEARCH_OPEN = '[Search Anything] open';

  static readonly TRACKER_GLOBAL_SEARCH_CLOSE = '[Search Anything] close';

  static readonly TRACKER_GLOBAL_SEARCH_FILTER_ENTITIES = '[Search Anything] filter entities';

  static readonly TRACKER_GLOBAL_SEARCH_SUGGEST_FEATURE_CLICK = '[Source Type] suggest feature click';

  static readonly TRACKER_GLOBAL_SEARCH_NO_RESULT = '[Search Anything] no results found';

  static readonly TRACKER_GLOBAL_SEARCH_RESULT_CLICK = '[Search Anything] item click';

  static readonly TRACKER_GLOBAL_SEARCH_RESULT_VIEW_ALL_CLICK = '[Search Anything] view all click';

  static readonly TRACKER_GLOBAL_ENTITY_FILTERS_APPLIED = '[Search Anything] entity filters applied';
}
